export const ConsoleSentHistoryIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 1.33337L13.9998 4.66671L14 13.995C14 14.366 13.7034 14.6667 13.3377 14.6667H2.66227C2.29651 14.6667 2 14.3632 2 14.0055V1.99457C2 1.62941 2.29833 1.33337 2.66567 1.33337H10.6667ZM10 2.66671H3.33333V13.3334H12.6667V5.33337H10V2.66671ZM8.66667 6.00004V8.66671H10.6667V10H7.33333V6.00004H8.66667Z"
      fill="currentColor"
    />
  </svg>
);

export default ConsoleSentHistoryIcon;
